import {userProfileManager} from '../../util/user-profile-manager';
import {bankInfoAdapter} from './adapters/bank-info-adapter';
import BankService from './bank-service';

export var BankInfoService = function($http, $q, configManager, AccountConfigManager) {
    var bankInfo = {};
    var countriesUsingAtlas = 'US, CA, AU, NZ, SG, MY, TH, PH, HK';

    var accountConfigManager = AccountConfigManager.getConfig(configManager);
    var countryCode = accountConfigManager.site['countryCode'];

    var sapEndpoint = accountConfigManager.site['legacyServer'];
    var atlasServiceUrl = accountConfigManager.system['atlas_service_url'];

    var jwt_token = userProfileManager.getJWT();
    var atlasServiceEndPoint = atlasServiceUrl + 'bank-info/{accountId}.json?eid=' + jwt_token;
    var accountServiceEndPoint = sapEndpoint + '/customer/api/v1/account/{accountId}';

    var accountId = userProfileManager.getUserProfileMasterInfo().accountId;

    var headerConfig = {
        headers: {
            'content-type': 'application/json',
            'showgloballoader': true
        }
    };


    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    bankInfo.getBankInfoForAccount = function() {
        // for atlas markets, check to see if the distributor has bank info saved
        if (useAtlasServiceCall(countryCode)) {
            return BankService($http, $q, configManager, AccountConfigManager, userProfileManager).isDistributorEligible()
                .then(function(res) {
                    // if the distributor is eligible, they do not have bank info on file
                    if (res.data.eligible) {
                        // successfully processed but no content, return 204
                        return Promise.resolve({status: 204});
                    } else {
                        // if the distributor is not eligible, they have bank info saved
                        return getBankInfoUsingAtlas();
                    }
                });
        } else {
            // for markets using SAP, return bank info
            return getBankInfoUsingSAP();
        }
    };

    bankInfo.writeBankInfoToAccount = function(data) {
        var bankInfoPromise;

        if (useAtlasServiceCall(countryCode)) {
            bankInfoPromise = writeBankUsingAtlas(data);
        } else {
            bankInfoPromise = writeBankUsingSAP(bankInfoAdapter().getSAPPayloadFromAtlasPayload(data));
        }

        return bankInfoPromise;
    };

    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------

    /**
     * useAtlasServiceCall
     * @param {String} countryCode
     * @return {boolean}
     */
    function useAtlasServiceCall(countryCode) {
        return countriesUsingAtlas.indexOf(countryCode) !== -1;
    }

    /**
     * getBankInfoUsingAtlas
     * @return {Request}
     */
    function getBankInfoUsingAtlas() {
        var url = atlasServiceEndPoint.replace('{accountId}', accountId);
        return $http.get(url, headerConfig);
    }

    /**
     * Gets bankInfo using SAP
     * @return {Promise}
     */
    function getBankInfoUsingSAP() {
        var url = accountServiceEndPoint.replace('{accountId}', accountId);

        var deferred = $q.defer();

        // todo we may be able to just return $http and not use the "deferred".
        $http.get(url, headerConfig).then(function(response) {
            deferred.resolve(bankInfoAdapter().getAtlasResponseFromSAPResponse(response));
        });

        return deferred.promise;
    }

    /**
     * writeBankUsingAtlas
     * @param {Object} data
     * @return {Promise}
     */
    function writeBankUsingAtlas(data) {
        var url = atlasServiceEndPoint.replace('{accountId}', accountId);
        return $http.post(url, data, headerConfig);
    }

    /**
     * writeBankUsingSAP
     * @param {Object} data
     * @return {Promise}
     */
    function writeBankUsingSAP(data) {
        var url = accountServiceEndPoint.replace('{accountId}', accountId);
        var deferred = $q.defer();

        $http.put(url, data, headerConfig).then(function(response) {
            deferred.resolve(bankInfoAdapter().getAtlasResponseFromSAPResponse(response));
        }, function(reason) {
            deferred.resolve(reason);
        });

        return deferred.promise;
    }

    return bankInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/bank-info-service.js
// module id = 25
// module chunks = 0